export enum MapBorderType {
    TWO_WAY = 0,
    ONE_WAY = 1,
};

export enum MapBorderLineType {
    Straight = 0,
    Quadratic = 1,
    DomId = 2,
};

export const MAP_BORDER_LINE_CURVED_DEFAULT_CURVINESS = 0.25;
